export enum MoodTrackingRoutes {
  HISTORY = 'moodTrackingHistory',
  NEW_ENTRY = 'moodTrackingNewEntry',
}
